
<template>
	<c-dialog ref="dialog" title="选择模板" width="600" height="400" enable-flex :button="false">
		<c-tips v-if="printerError"><p v-html="printerError"></p></c-tips>
		<c-tab-list v-if="tabList.length > 1" ref="tabList" :tabs="tabList" :immediate="false" type="card" @change="tabHandle"></c-tab-list>
		<c-table ref="table" height="grow" :paging="false">
		    <c-table-column label="模板类型"  name="template_type" width="80">
			    <template #default="{data}">
				    <c-state dict="templateTypeName" :value="data.template_type"></c-state>
			    </template>
		    </c-table-column>
		    <c-table-column label="模板名称"  name="template_name" width="250">
			    <template #default="{data}">
				    <span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>{{data.template_name}}
			    </template>
		    </c-table-column>
			<c-table-column
				label="纸张大小"
				width="120"
			>
				<template #default="{data}">
					<span v-if="data.template_type == 1">{{data.width}}mm x {{data.height}}mm</span>
					<template v-else>
						<span v-if="data.width && data.height">
							<c-state dict="paperSize" :value="`${data.width}x${data.height}`"></c-state>
							<span v-if="!$store.state.dictData.paperSize[`${data.width}x${data.height}`]">{{data.width}}cm x {{data.height}}cm</span>
						</span>
						<span v-else>-</span>
					</template>
				</template>
			</c-table-column>
		    <c-table-column type="button" label="操作" width="120">
				<template #default="{data}">
					<c-table-button v-if="data.template_type != 3" @click="handle(data)">打印</c-table-button>
					<c-table-button v-if="data.template_type == 2" @click="handle(data, true)">下载</c-table-button>
					<c-table-button v-if="data.template_type == 3" @click="handle(data, true)">导出</c-table-button>
				</template>
			</c-table-column>
	    </c-table>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex';
	import getLodop from '@/assets/script/lodop.js'

	export default {
	    name: 'exportTemplateSelector',

		props: {
			workType: [Number, String],
			templateType:[Number, String]   //模板类型  1=内置模板（HTML代码）  2=Excel模板  3=Excel列表模板
		},
		
		data() {
			return {
				printerError: '',
				currentTab: 1,
				templateList:[]
			}
		},

	    computed: {
		    // 获取dictName选项数据
	        ...mapState(['systemConfig', 'templateTypeName']),

		    tabList() {
			    let list = [];
			    if (this.templateType && this.templateType.toString()==3) {
				    list.push({"value":3,"name": "Excel列表模板"});
			    }else {
				    if (!['1','2','4','5','6','14','32','34','35','36','39','40','42','43','45','47','51'].includes(this.workType.toString())) {
					    list.push({"value":1, "name": "内置模板"});
				    }
				    if (!['9','16','26','27','50'].includes(this.workType.toString())) {
					    list.push({"value":2,"name": "Excel模板"});
				    }
			    }
			    return list;
		    },

		    dialogTitle() {
			    return {
				    1: '【销售订单】',
				    2: '【生产计划】',
				    3: '【工单】',
				    4: '【入库单】',
				    5: '【出库单】',
				    6: '【盘点单】',
				    7: '【产品信息】',
				    8: '【不良品项】',
				    9: '【工序】',
				    10: '【工艺路线】',
				    11: '【客户】',
				    12: '【供应商】',
				    13: '【任务】',
				    14: '【报工】',
				    15: '【物料清单】',
				    16: '【库存收发明细】',
				    17: '【库存余额】',
				    18: '【库存余额明细】',
				    19: '【进销存汇总】',
				    25: '【库存变更记录】',
				    26: '【仓库】',
				    27: '【用户】',
				    29: '【委外单】',
					32: '【发货单】',
				    33: '【发货单明细】',
					34: '【装配工单】',
                    35: '【委外动态】',
                    36: '【委外结算单】',
                    39: '【采购单】',
					40: '【采购单明细】',
					41: '【销售订单明细】',
                    42: '【报工检验】',
                    43: '【报工检验处理】',
					45:	'【生产入库检】',
					47:	'【生产入库检验处理】',
					50:	'【任务类型】',
					51:	'【协同任务】'
			    }[this.workType]
		    }
	    },

		methods: {
			open(data = {}) {
				this._excelParams = data.excelParams;
				this._htmlParams = data.htmlParams;
				if (this.tabList.length == 1){
					this.currentTab = this.tabList[0].value;
					this.loadTemplate();
				} else {
					this.$refs.tabList.changeIndex(0);
				}
				this.$refs.dialog.open({
					title: `${this.dialogTitle}${this.templateType == 3 ? '导出' : '打印'}`
				});

				if (this.systemConfig.print_type == 2) {
					this.printerError = '';
					if (this.tabList.find(item => item.value == 2)) {
						getLodop().catch(e => {
							this.printerError = e;
						});
					}
				}
			},

			tabHandle(tab) {
				this.currentTab = tab.value;
				this.loadTemplate();
			},
			
			//加载列表
			 loadTemplate() {
				 this.$refs.table.load({
					 url: '/export/template/list',
					 data: {
						 template_type: this.currentTab,
						 work_type: this.workType
					 },
					 dataFormatter: data => {
						if (this.currentTab == 1) {
							data.forEach(item => {
								let [width, height] = JSON.parse(item.template_config).paper.split('x');
								item.width = width;
								item.height = height;
							});
						}
						return data;
					 },
					 success: () => {
						 var list = this.$refs.table.getRow();
						 if (list && list.length > 0){
							 this.$refs.table.getRow(0).update({
								 _selected: true
							 })
						 }
					 }
				 });
			 },

			 /**
			  * 确认相应事件
			  * **/
  			 handle(data, download) {
				if (data.template_type == 2 && !download && this.printerError) {
					this.$message({
						message: '请检查CLodop云打印服务是否正常启动'
					})
					return;
				}
				if (data.template_type == 2 || data.template_type == 3) {
					this.request({
						url: '/export/url',
						data: Object.assign({
							export_type: data.template_type,  // 导出数据类型 1：内置模板  2：Excel打印模板  3：Excel导出模板
							template_id: data.id
						}, this._excelParams),
						loading: true,
						success: data => {
							if (download) {
								this.download({
									signFree: true,
									fileName: data.filename,
									url: data.url,
									loading: {
										message: '数据文件生成中...'
									}
								})
							} else {
								if (this.systemConfig.print_type != 2) {
									this.$print(data.pdf_url);
								} else {
									this.request({
										url: data.url,
										loading: {
											message: '数据文件加载中...'
										},
										response: data => {
											getLodop().then(LODOP => {
												LODOP.PRINT_INIT("单据打印");
												LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', data.obj);
												LODOP.PREVIEW();
											});
										},
										error: () => {
											return false;
										}
									});
								}
							}
							this.$refs.dialog.close();
						}
					});
				} else {
					this.templatePrint(Object.assign({
						template_id: data.id
					}, this._htmlParams));
					this.$refs.dialog.close();
				}
			}
		}
	}
</script>